import React, { Component } from 'react';
import { connect } from 'dva';
import { Button, Row, Col, Form, Input, DatePicker, Tabs, Select } from 'antd';
import { ENV } from '@/services/utils';
import Container from '../../../../../components/Container';
import ListPage from '../../../../../components/ListPage';
import { getAppCode } from '../../utils/utils';
import { getLabelStrData } from '../../utils/convertData';
import { columns, HotColumns } from './tableHeader';
import styles from './index.less';

const hostName = {
  test: 'test.m.xiaoyuanhao.com',
  dev: 'test.m.xiaoyuanhao.com',
  production: 'm.xiaoyuanhao.com',
};

const { ListTable } = ListPage;
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;
const { Option } = Select;

@connect(({ user }) => ({
  orgid: user.currentUser.orgId,
}))
class LatestNews extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: [],
      loading: false,
      totalElements: 0,
      params: {
        title: '',
        orgName: '',
        bureauid: props.orgid,
        newsLabelId: 0,
        start_time: '',
        end_time: '',
        appCode: getAppCode(),
        page: 1,
        pageSize: 10,
        type: 'outputDate',
        newsLabelId: '',
      },
      activeKey: 'key1',
      labelList: [],
    };
  }

  componentDidMount() {
    const { params } = this.state;
    this.fetchNewsLists(params);
    this.fetchLabelList();
  }

  fetchNewsLists = params => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'latestNews/fetchNewestNews',
      params,
    })
      .then(res => {
        this.setState({
          loading: false,
          dataSource: getLabelStrData(res),
          totalElements: res.totalElements,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  // 获取标签列表
  fetchLabelList = () => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'latestNews/fetchLabelList',
      params: { appCode: getAppCode() },
    })
      .then(res => {
        const arr = [];
        (res || []).forEach(item => {
          arr.push({ ...item, checked: false });
        });
        this.setState({ labelList: arr, loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  // 切换Tab
  changeTabs = key => {
    const { params } = this.state;
    this.setState(
      {
        dataSource: [],
        activeKey: key,
        params: {
          ...params,
          page: 1,
          pageSize: 10,
          type: key === 'key1' ? 'outputDate' : 'clickCount',
          newsLabelId: '',
        },
      },
      () => {
        const { params: tempArr } = this.state;
        this.fetchNewsLists(tempArr);
      }
    );
  };

  search = e => {
    e.preventDefault();
    const { form } = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const { params } = this.state;
        const rangeValue = values['range-picker'];
        const tempParams = {
          ...params,
          title: values.title ? encodeURIComponent(values.title) : '',
          orgName: values.orgname ? encodeURIComponent(values.orgname) : '',
          start_time: rangeValue && rangeValue[0] ? rangeValue[0].format('YYYYMMDD') : '',
          end_time: rangeValue && rangeValue[1] ? rangeValue[1].format('YYYYMMDD') : '',
          newsLabelId: values.newsLabelId ? values.newsLabelId : '',
          page: 1,
        };
        this.setState({
          params: tempParams,
        });
        this.fetchNewsLists(tempParams);
      }
    });
  };

  // 跳转详情
  handleGoToDetail = id => {
    window.open(`//${hostName[ENV]}/micro/app/micrositeV4/articleDetail?id=${id}`);
  };

  reSet = () => {
    const { form } = this.props;
    form.resetFields();
    const { params, activeKey } = this.state;
    const tempParams = {
      ...params,
      title: '',
      orgName: '',
      start_time: '',
      end_timg: '',
      newsLabelId: '',
      page: 1,
      type: activeKey === 'key1' ? 'outputDate' : 'clickCount',
    };
    this.setState({
      params: tempParams,
    });
    this.fetchNewsLists(tempParams);
  };

  changePage = (page, pageSize) => {
    const { params } = this.state;
    const tempParams = {
      ...params,
      page,
      pageSize,
    };
    this.setState({ params: tempParams });
    this.fetchNewsLists(tempParams);
  };

  render() {
    const { dataSource, params, totalElements, loading, activeKey, labelList = [] } = this.state;
    const { page } = params;
    const { form } = this.props;
    const { getFieldDecorator } = form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
    };

    const pageProps = {
      spinProps: { spinning: loading },
      className: styles.root,
    };

    const tableProps = {
      pageInfo: { totalElements, page },
      columns: activeKey === 'key1' ? columns : HotColumns,
      list: dataSource,
      rowKey: 'id',
      onItemClick: this.handleGoToDetail,
      onPageChange: this.changePage,
    };

    return (
      <Container breStates isSplitBar>
        <ListPage {...pageProps}>
          <Tabs onChange={this.changeTabs} activeKey={activeKey} type="card">
            <TabPane tab="最新资讯" key="key1" />
            <TabPane tab="热点资讯" key="key2" />
          </Tabs>
          <Row className={styles['search-area']}>
            <Col span={8}>
              <Form.Item {...formItemLayout} label="文章标题">
                {getFieldDecorator('title', {
                  rules: [
                    {
                      max: 50,
                      message: '请勿超过50个字!',
                    },
                  ],
                })(<Input placeholder="请输入标题" onPressEnter={this.search} />)}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...formItemLayout} label="发布组织">
                {getFieldDecorator('orgname', {
                  rules: [
                    {
                      max: 30,
                      message: '请勿超过30个字!',
                    },
                  ],
                })(<Input placeholder="请输入组织名称" onPressEnter={this.search} />)}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="发布时间" {...formItemLayout}>
                {getFieldDecorator(
                  `range-picker`,
                  {}
                )(<RangePicker format="YYYY-MM-DD" placeholder={['请选择', '请选择']} />)}
              </Form.Item>
            </Col>
            {activeKey === 'key1' && (
              <Col span={8} style={{ marginTop: 20 }}>
                <Form.Item {...formItemLayout} label="标签">
                  {getFieldDecorator('newsLabelId', {
                    initialValue: 0,
                  })(
                    <Select>
                      <Option value={0}>全部</Option>
                      {labelList.map(item => {
                        return <Option value={item.id}>{item.label}</Option>;
                      })}
                    </Select>
                  )}
                </Form.Item>
              </Col>
            )}
            {activeKey === 'key1' && <Col span={8} />}
            <Col
              span={activeKey === 'key1' ? 8 : 24}
              style={{ textAlign: 'right', marginTop: 20 }}
            >
              <Form.Item>
                <Button type="primary" onClick={this.search}>
                  查询
                </Button>
                <Button onClick={this.reSet}>重置</Button>
              </Form.Item>
            </Col>
          </Row>
          <section className="table-area">
            <ListTable {...tableProps} />
          </section>
        </ListPage>
      </Container>
    );
  }
}

const ArticleLatestNews = Form.create()(LatestNews);
export default ArticleLatestNews;
